import PhoneVerificationModal from "./PhoneVerificationModal";
export type { PhoneVerificationModalProps } from "./PhoneVerificationModal";
export default PhoneVerificationModal;
